import React, { useState } from 'react';
import { useContainerQuery } from '@colonist/ui';
import { SearchPlayerInput } from './SearchPlayerInput/SearchPlayerInput.tsx';
import { PlayerFilterDialogButton } from './PlayerFilterDialogButton.tsx';
import styles from './PlayerFilter.module.scss';
const NARROW_MAX_WIDTH = 159;
const query = {
    isNarrow: {
        maxWidth: NARROW_MAX_WIDTH
    }
};
/** Wrapper around `SearchPlayerInput` and `PlayerFilterDialogButton` to render each conditionally. */ export const PlayerFilter = ({ defaultValue = '', onSearch })=>{
    const [searchedValue, setSearchedValue] = useState(defaultValue);
    const [{ isNarrow }, containerRef] = useContainerQuery(query);
    const handleSearch = (username)=>{
        setSearchedValue(username);
        onSearch(username);
    };
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: styles.container
    }, isNarrow ? /*#__PURE__*/ React.createElement(PlayerFilterDialogButton, {
        onSearch: handleSearch,
        searchedValue: searchedValue
    }) : /*#__PURE__*/ React.createElement(SearchPlayerInput, {
        onSearch: handleSearch,
        defaultValue: searchedValue,
        flatBottom: true,
        searchOnClear: true
    }));
};
